import { render, staticRenderFns } from "./SortableIcon.vue?vue&type=template&id=e286668e&scoped=true"
import script from "./SortableIcon.vue?vue&type=script&lang=js"
export * from "./SortableIcon.vue?vue&type=script&lang=js"
import style0 from "./SortableIcon.vue?vue&type=style&index=0&id=e286668e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e286668e",
  null
  
)

export default component.exports